import React from "react";
import clsx from "clsx";
import useClasses from "../useClasses";

function CustomDrawer({ open, content, width, hasTransition = true }) {
  //const classes = useStyles({ width, hasTransition });

  const styles = (theme) => ({
    root: {
      position: "fixed",
      zIndex: theme.zIndex.appBar - 1,
      height: "100%",
    },
    drawer: {
      //boxShadow: theme.shadows[2],
      borderRight: "1px solid rgba(0, 0, 0, 0.12)",
      boxShadow: "none",
      whiteSpace: "nowrap",
      background: theme.palette.background.toolbar,
      overflowX: "hidden",
      height: "100%",
    },
    drawerOpen: {
      width: width,
      transition: hasTransition
        ? theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          })
        : "none",
      overflowX: "hidden",
    },
    drawerClose: {
      transition: hasTransition
        ? theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          })
        : "none",
      overflowX: "hidden",
      width: 0,
      border: 0,
    },
  });
  const classes = useClasses(styles);
  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
      >
        {content}
      </div>
    </div>
  );
}

export default CustomDrawer;
